import React, { useEffect, useState } from 'react';
import {
  Row,
  Col,
} from 'reactstrap';
import connect from 'react-redux/es/connect/connect';
import { checkPermission } from '../../utils/Auth/AuthService';
import CalloutWidget from '../../components/Widgets/Callout';
import {
  getDashboardBills,
  getDashboardFavourites,
  getOpenTickets,
  removeFavouriteFromDashboard,
  toggleAccountSummaryLoading,
  toggleBillsLoading,
  toggleTicketsLoading,
} from '../../store/dashboard/actions';
import { IDashboardState } from '../../store/dashboard/types';
import { ACCOUNT_TYPE_RESALE_PARTNER, IAccountState } from '../../store/account/types';
import ContactCard from '../../components/Widgets/ContactCard';
import BillingTable from '../../components/Widgets/BillingTable';
import { IMonitoringState } from '../../store/monitoring/types';
import MonitoringFavourites from '../../components/MonitoringFavourites';
import MonitoredItemEmpty from '../../components/Widgets/MonitoredItemEmpty';
import Section from '../../components/Section';
import { getAccountSummary } from '../../store/account/actions';
import { IUserState } from '../../store/user/types';
import { unFavouriteItem } from '../../store/user/actions';
import { resetSystemConfirmation, setSystemConfirmation } from '../../store/system/actions';

import { ISystemState } from '../../store/system/types';
import { AppDispatch } from '../../configureStore';
import OpenTicketsTable from 'components/Widgets/TicketsTable';

type DashboardProps = {
  dispatch: AppDispatch;
  account: IAccountState;
  dashboard: IDashboardState;
  monitoring: IMonitoringState;
  user: IUserState;
  system: ISystemState;
};
const Dashboard: React.FC<DashboardProps> = (props) => {

  const {
    account, dashboard: {
      loadingBills, loadingTickets, favourites, loadingSummary, bills, tickets,
    }, user: { favourites: userFavourites }, dispatch, system,
  } = props;
  const isResalePartnerAccount = account.accountTypeCode === ACCOUNT_TYPE_RESALE_PARTNER;
  const accountId = isResalePartnerAccount ? system.activePartnerCustomer.accountId : account.accountId;
  const [activeTicketCount, setActiveTicketCount] = useState(0);
  
  useEffect(() => {
    const activeTickets = tickets.filter(ticket => ticket.status === 'Active');
    setActiveTicketCount(activeTickets.length);
  }, [tickets]);

  useEffect(() => {


    if (
      (
        checkPermission('billing.read', props.user.permissions)
        || checkPermission('billing.write', props.user.permissions)
      )
          && bills.length === 0
    ) {

      dispatch(toggleBillsLoading());
      dispatch(getDashboardBills()).then(() => dispatch(toggleBillsLoading()));

    }
    if (tickets.length === 0) {

      dispatch(toggleTicketsLoading());
      dispatch(getOpenTickets()).then(() => dispatch(toggleTicketsLoading()));

    }
    if (!account.accountNumber) {

      dispatch(toggleAccountSummaryLoading());
      dispatch(getAccountSummary()).then(() => {

        dispatch(toggleAccountSummaryLoading());

      });

    }

    if (checkPermission('monitoring.read', props.user.permissions)) {

      dispatch(getDashboardFavourites(userFavourites, accountId));

    }

  }, []);
  const removeWidget = (id: string, name: string, location: string) => {

    dispatch(setSystemConfirmation(
      {
        text: 'It will remove this item from your dashboard.',
        isOpen: true,
        color: 'danger',
        proceed: () => {

          dispatch(removeFavouriteFromDashboard(id));
          dispatch(unFavouriteItem(id, name, location));
          dispatch(resetSystemConfirmation());

        },
        cancel: () => {

          dispatch(resetSystemConfirmation());

        },
      },
    ));

  };
  return (
    <div className="animated fadeIn">
      <Row>
        <Col className="d-flex">
          <CalloutWidget
            loading={loadingSummary}
            color="syntura-info"
            value={account.activeServices}
            title="Live Services"
            link={checkPermission('services.read', props.user.permissions) ? '/services' : '#'}
          />
        </Col>
        <Col className="d-flex">
          <CalloutWidget
            loading={loadingTickets}
            color="syntura-primary"
            value={activeTicketCount}
            title="Active Tickets"
            link={checkPermission('cases.read', props.user.permissions) ? '/tickets' : '#'}
          />
        </Col>
        <Col className="d-flex">
          <CalloutWidget
            loading={loadingSummary}
            color="syntura-tertiary"
            value={account.activeOrders}
            title="Open Orders"
            link={checkPermission('orders.read', props.user.permissions) ? '/orders' : '#'}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col md={7}>
          {checkPermission('monitoring.read', props.user.permissions)
                        && (
                        <Row className="d-flex align-items-stretch">
                          <MonitoringFavourites favourites={favourites} deleteFavourite={removeWidget} />
                          <Col lg={6} md={6} sm={6} className="mb-4 d-flex col-xl-3 col-xxl-3">
                            <MonitoredItemEmpty />
                          </Col>
                        </Row>
                        )}
          {(checkPermission('billing.read', props.user.permissions) || checkPermission('billing.write', props.user.permissions))
                        && (
                        <Row className="mt-3">
                          <Col>
                            <BillingTable bills={bills} loading={loadingBills} />
                          </Col>
                        </Row>
                        )}
        </Col>
        <Col md={5}>
          <Row className="mb-3">
            <Col>
              <Section title="Account manager">
                <ContactCard
                  loading={loadingSummary}
                  dropShadow
                  firstName={account.accountManager && account.accountManager.firstName}
                  lastName={account.accountManager && account.accountManager.lastName}
                  email={account.accountManager && account.accountManager.email}
                  phone={account.accountManager && account.accountManager.telephone}
                  jobTitle="Account Manager"
                />
              </Section>
            </Col>
          </Row>
          <Row className="mt-3 mb-5">
            <Col>
              <OpenTicketsTable loading={loadingTickets} tickets={tickets} />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );

};
function mapStateToProps({
  account, dashboard, monitoring, user, system,
}) {

  return {
    account,
    dashboard,
    monitoring,
    user,
    system,
  };

}
export default connect(mapStateToProps)(Dashboard);
